export default __webpack_public_path__ + "42f1697b033b4f1b27d757fe4ee5ec9a.jpg";